import apiClient from '../../../services/apiClient';
import store from "@/store/store";

export default {
	namespaced: true,
	state: {
		moduleInvoices: null,
		init: null,
	},
	getters: {
		moduleInvoices(state) {
			return state.moduleInvoices;
		},
	},
	mutations: {
		SET_MODULE_INVOICE(state, moduleInvoices) {
			state.moduleInvoices = moduleInvoices
		},
		CLEAR_STORE(state) {
			state.init = null;
			state.moduleInvoices = null;
		}
	},
	actions: {
		async init({commit}, state) {
			if (!this.state.init) {
				await apiClient.get('modules/invoice/get').then(res => {
					commit('SET_MODULE_INVOICE', res.data);
					this.state.init = true;
				}).catch(err => {
				})
			}
		},
		activate({commit}) {
			return store.dispatch('invoices/moduleUpdate', {active: 1});
		},
		deactivate({commit}) {
			return store.dispatch('invoices/moduleUpdate', {active: 0});
		},
		moduleUpdate({commit}, params) {
			return new Promise((resolve, reject) => {
				apiClient.put('modules/invoice/update', params).then(res => {
					commit('SET_MODULE_INVOICE', res.data);
					resolve(res.data);
				}).catch(err => {
					reject(err);
				})
			});
		},
		async clear({commit}) {
			commit('CLEAR_STORE')
		}
	}
}
